import axios from "axios";
import qs from "qs";
import { Message } from "@arco-design/web-react";

export const baseUrl = process.env.REACT_APP_BASE_URL;

axios.defaults.withCredentials = true;

const instance = axios.create({
    baseURL: baseUrl,
    paramsSerializer: {
        serialize: (params) => qs.stringify(params, { indices: false })
    }
});

let isSessionExpired = false;

const handleSessionExpired = () => {
    if (isSessionExpired) return;
    isSessionExpired = true;
    localStorage.removeItem("login.token");
    Message.error("Session expired, please log in again.");
    window.location.href = "/login";
};

const handleResponse = (response) => {
    let responseBody = response.data;
    if (responseBody.status === "OK") {
        return responseBody.data;
    } else {
        if (responseBody.status === "401") {
            handleSessionExpired();
            return Promise.reject(responseBody);
        }
        let errorMsg = "[" + responseBody.status + "]" + responseBody.message
        console.error(errorMsg);
        return Promise.reject(responseBody);
    }
}

const handleError = (err) => {
    if (err.response) {
        if (err.response.status === 401) {
            handleSessionExpired();
            return Promise.reject(err.response.data);
        }
        return Promise.reject(err.response.data);
    }
    return Promise.reject(err);
}

export const get = async (path, params, ...httpParams) => {
    try {
        let response = await instance.get(path, {
            params: params,
            headers: { 'bee-access-token': localStorage.getItem("login.token") },
            ...httpParams
        });
        return handleResponse(response);
    } catch (err) {
        return handleError(err);
    }
}

export const getBlob = async (path, params) => {
    try {
        let response = await instance.get(path, {
            params: params,
            headers: { 'bee-access-token': localStorage.getItem("login.token") },
            responseType: 'blob'
        });
        return response;
    } catch (err) {
        return handleError(err);
    }
}

export const post = async (path, params, ...httpParams) => {
    try {
        let response = await instance.post(path, params, {
            headers: { 'bee-access-token': localStorage.getItem("login.token") },
            ...httpParams
        });
        return handleResponse(response);
    } catch (err) {
        return handleError(err);
    }
}

export const postBlob = async (path, params, queryParams) => {
    try {
        let response = await instance.post(path, params, {
            headers: { 'bee-access-token': localStorage.getItem("login.token") },
            params: queryParams,
            responseType: 'blob'
        });
        return response;
    } catch (err) {
        return handleError(err);
    }
}

export const put = async (path, params) => {
    try {
        let response = await instance.put(path, params, {
            headers: { 'bee-access-token': localStorage.getItem("login.token") }
        });
        return handleResponse(response);
    } catch (err) {
        return handleError(err);
    }
}

export const del = async (path, params) => {
    try {
        let response = await instance.delete(path, {
            params: params,
            headers: { 'bee-access-token': localStorage.getItem("login.token") }
        });
        return handleResponse(response);
    } catch (err) {
        return handleError(err);
    }
}
